import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../../utils';
import DesktopDirections from './DesktopDirections/DesktopDirections';
import MobileDirections from './MobileDirections/MobileDirections';
const DirectionsSection = ({ cities }) => {
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    return (React.createElement(React.Fragment, null,
        !isMobile && React.createElement(DesktopDirections, { cities: cities }),
        isMobile && React.createElement(MobileDirections, { cities: cities })));
};
export default DirectionsSection;
